import Header from './Header';
import Footer from './Footer';
import { Link } from 'react-router-dom'; 
import tmobileLogo from '../assets/t-mobile.png';
import verizonLogo from '../assets/verizon.png';
import attLogo from '../assets/AT.png';
import simpleLogo from '../assets/simple-mobile.jpg';
import ultraLogo from '../assets/ultra.png';
import h2oLogo from '../assets/h2O.png';
import mobilexLogo from '../assets/mobx.jpg';
import lycaLogo from '../assets/lyca.png';

export default function FareFuelMobileBillPayLandingPage() {
   const carriers = [
      { name: 'T-Mobile', logo: tmobileLogo },
      { name: 'Verizon', logo: verizonLogo },
      { name: 'AT&T', logo: attLogo },
      { name: 'Simple Mobile', logo: simpleLogo },
      { name: 'Ultra Mobile', logo: ultraLogo },
      { name: 'H2O Wireless', logo: h2oLogo },
      { name: 'MobileX', logo: mobilexLogo },
      { name: 'Lycamobile', logo: lycaLogo },
   ];

   const steps = [
      {
         title: 'Schedule a Pickup',
         text: 'Book a bottles and cans pickup from your home through FareFuel. Choose a convenient date and time, and our driver comes to you.',
         icon: '1',
      },
      {
         title: 'Earn Redeem Credit',
         text: 'After your recyclables are collected and processed, the eligible redeem value is posted to your FareFuel account as Redeem Credit.',
         icon: '2',
      },
      {
         title: 'Apply Credit to Your Bill',
         text: 'Use your available Redeem Credit toward your monthly mobile bill. If needed, pay any remaining balance using an approved payment method.',
         icon: '3',
      },
   ];

   const highlights = [
      'Home pickup convenience',
      'Redeem Credit applied first',
      'Simple monthly bill payments',
      'Eco-friendly savings',
   ];

   return (
      <div className="">
         <Header />
      <div className="min-h-screen bg-[#f3fbf5] text-[#1a4632]">
         <section className="relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(132,204,22,0.25),transparent_30%),radial-gradient(circle_at_left,rgba(34,197,94,0.2),transparent_25%)]" />
            <div className="relative mx-auto max-w-7xl px-6 py-10 md:px-10 lg:px-12">
               
               <div className="grid gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:items-center">
                  <div>
                     {/* <div className="mb-4 inline-flex items-center rounded-full border border-green-300 bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
                        Mobile Bill Pay Powered by Recycling
                     </div> */}
                     <h1 className="max-w-3xl text-3xl font-bold leading-tight md:text-4xl lg:text-5xl text-[#1a4632]">
                        Turn bottles & cans into <span className="text-lime-600">monthly mobile bill payments</span>
                     </h1>
                     <p className="mt-5 max-w-2xl text-base leading-7 text-green-800 md:text-lg">
                        FareFuel helps customers convert eligible recycling redeem value into Redeem Credit that can be applied toward monthly mobile phone bills with supported carriers.
                     </p>

                     <div className="mt-6 flex flex-wrap gap-3">
                           <Link
                              to="/login"
                              className="inline-block rounded-2xl bg-lime-500 px-5 py-3 text-sm font-semibold text-white transition hover:bg-lime-600"
                           >
                              Get Started
                           </Link>

                           <Link
                              to="/recycle-process"
                              className="inline-block rounded-2xl border border-green-300 bg-white px-5 py-3 text-sm font-semibold text-green-800 transition hover:bg-green-50"
                           >
                              How It Works
                           </Link>
                     </div>

                     <div className="mt-8 flex flex-wrap gap-3">
                        {highlights.map((item) => (
                           <div
                              key={item}
                              className="rounded-full border border-green-200 bg-green-100 px-3 py-1 text-sm text-green-800"
                           >
                              {item}
                           </div>
                        ))}
                     </div>
                  </div>

                  <div className="rounded-[28px] border border-green-200 bg-white p-4 shadow-xl">
                     <div className="rounded-[24px] bg-[#ecfdf5] p-5">
                        <div className="mb-4 flex items-center justify-between">
                           <div>
                              <div className="text-sm text-green-600">Example Bill Pay Flow</div>
                              <div className="text-xl font-semibold text-[#1a4632]">Redeem Credit Applied First</div>
                           </div>
                           <div className="rounded-2xl bg-lime-100 px-3 py-2 text-sm font-semibold text-lime-700">
                              Secure Checkout
                           </div>
                        </div>

                        <div className="space-y-3 rounded-3xl bg-white p-4">
                           <div className="flex items-center justify-between text-sm">
                              <span className="text-green-600">Carrier</span>
                              <span className="font-medium">T-Mobile</span>
                           </div>
                           <div className="flex items-center justify-between text-sm">
                              <span className="text-green-600">Monthly Bill</span>
                              <span className="font-medium">$60.00</span>
                           </div>
                           <div className="flex items-center justify-between text-sm">
                              <span className="text-green-600">Redeem Credit</span>
                              <span className="font-medium text-lime-600">-$38.50</span>
                           </div>
                           <div className="h-px bg-green-200" />
                           <div className="flex items-center justify-between text-base">
                              <span className="text-green-800">Remaining Balance</span>
                              <span className="font-semibold">$21.50</span>
                           </div>
                        </div>

                        <div className="mt-4 rounded-3xl border border-amber-200 bg-amber-50 p-4">
                           <div className="text-sm font-semibold text-amber-700">Stripe-safe service description</div>
                           <p className="mt-2 text-sm leading-6 text-amber-800">
                              FareFuel uses payment processing only to collect customer bill-payment amounts related to wireless/mobile service bills.
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         {/* KEEPING REST SAME STRUCTURE — ONLY COLORS CHANGED */}

         <section className="mx-auto max-w-7xl px-6 py-8 md:px-10 lg:px-12">
            <div className="rounded-[28px] border border-green-200 bg-white p-6 shadow-xl">
               <h2 className="text-2xl font-semibold text-[#1a4632]">Supported Carriers</h2>

               <div className="grid grid-cols-2 gap-4 md:grid-cols-4 mt-6">
                  {carriers.map((carrier) => (
                     <div
                        key={carrier.name}
                        className="rounded-[24px] border border-green-200 bg-[#f0fdf4] p-4 transition hover:-translate-y-0.5 hover:border-emerald-400/30"
                     >
                        <div className="flex h-24 w-24 items-center justify-center rounded-2xl bg-white p-2 shadow-sm">
                           <img
                              src={carrier.logo}
                              alt={carrier.name}
                              className="h-full w-full object-contain"
                           />
                        </div>
                        <div className="text-base font-semibold text-[#1a4632]">{carrier.name}</div>
                        <div className="text-sm text-green-700">Monthly bill pay supported</div>
                     </div>
                  ))}
               </div>
            </div>
         </section>

         <section className="bg-[#e6f9ec] py-10">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-5">
               {steps.map((step) => (
                  <div key={step.title} className="bg-white rounded-2xl p-6 shadow">
                     <div className="w-12 h-12 bg-lime-500 text-white flex items-center justify-center rounded-xl mb-3 font-bold">
                        {step.icon}
                     </div>
                     <h3 className="text-lg font-semibold text-[#1a4632]">{step.title}</h3>
                     <p className="text-sm text-green-700 mt-2">{step.text}</p>
                  </div>
               ))}
            </div>
         </section>


            <section className="mx-auto max-w-7xl px-6 py-8 md:px-10 lg:px-12">
               <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">

                  {/* LEFT CARD */}
                  <div className="rounded-[28px] border border-green-200 bg-white p-6 shadow-xl">
                     <div className="text-sm font-medium uppercase tracking-[0.2em] text-green-600">
                        Why FareFuel
                     </div>

                     <h2 className="mt-2 text-3xl font-semibold text-[#1a4632]">
                        Simple for customers. Safe for billing.
                     </h2>

                     <p className="mt-4 text-sm leading-7 text-green-800">
                        FareFuel is designed to make recycling more useful in everyday life.
                        Instead of letting redeem value sit unused, customers can apply it directly
                        toward a household expense like a monthly phone bill.
                     </p>

                     <div className="mt-5 space-y-3">
                        {[
                           'Schedule a pickup from home',
                           'Drivers collect bottles and cans at your location',
                           'Redeem value is posted to your FareFuel account',
                           'Credit is applied first before any remaining payment is charged',
                        ].map((item) => (
                           <div
                              key={item}
                              className="flex items-start gap-3 rounded-2xl bg-green-50 p-3"
                           >
                              
                              <div className="text-sm text-green-900">{item}</div>
                           </div>
                        ))}
                     </div>
                  </div>

                  {/* RIGHT CARD */}
                  <div className="rounded-[28px] border border-green-200 bg-[#f6fff8] p-6 shadow-xl">
                     <div className="text-sm font-medium uppercase tracking-[0.2em] text-green-600">
                        Compliance-Friendly Messaging
                     </div>

                     <h2 className="mt-2 text-3xl font-semibold text-[#1a4632]">
                        Clear bill-pay wording for payment gateway reviews
                     </h2>

                     <div className="mt-5 space-y-4">

                        <div className="rounded-3xl border border-green-200 bg-white p-5">
                           <div className="text-sm font-semibold text-lime-600">
                              Approved positioning
                           </div>
                           <p className="mt-2 text-sm leading-7 text-green-800">
                              FareFuel enables customers to apply recycling-based Redeem Credit toward
                              eligible monthly mobile phone bills.
                           </p>
                        </div>

                        <div className="rounded-3xl border border-green-200 bg-white p-5">
                           <div className="text-sm font-semibold text-lime-600">
                              Important clarification
                           </div>
                           <p className="mt-2 text-sm leading-7 text-green-800">
                              Payment processing on this page is limited to the collection of consumer
                              mobile bill payments.
                           </p>
                        </div>

                        <div className="rounded-3xl border border-green-200 bg-white p-5">
                           <div className="text-sm font-semibold text-lime-600">
                              Operational explanation
                           </div>
                           <p className="mt-2 text-sm leading-7 text-green-800">
                              Customers first earn credit from eligible bottles and cans that are
                              picked up and processed.
                           </p>
                        </div>

                     </div>
                  </div>
               </div>
            </section>


            {/* CTA SECTION */}
            <section className="mx-auto max-w-7xl px-6 py-10 md:px-10 lg:px-12">
               <div className="rounded-[32px] border border-green-200 bg-gradient-to-br from-lime-100 via-white to-green-100 p-8 shadow-2xl">

                  <div className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">

                     {/* LEFT */}
                     <div>
                        <div className="text-sm font-medium uppercase tracking-[0.2em] text-green-600">
                           Get Started
                        </div>

                        <h2 className="mt-2 text-3xl font-semibold md:text-4xl text-[#1a4632]">
                           Schedule your pickup and turn recycling into real savings
                        </h2>

                        <p className="mt-4 max-w-2xl text-sm leading-7 text-green-800">
                           Customers only need to schedule a bottles and cans pickup. FareFuel drivers
                           come right to the house and collect recyclables.
                        </p>
                     </div>

                     {/* RIGHT */}
                     <div className="flex flex-col gap-3 rounded-[28px] border border-green-200 bg-white p-5">
                        <Link
                           to="/login"
                           className="inline-block text-center w-full rounded-2xl bg-lime-500 px-5 py-3 text-sm font-semibold text-white transition hover:bg-lime-600"
                        >
                           Schedule Pickup Now
                        </Link>

                        <button className="rounded-2xl border border-green-300 bg-white px-5 py-3 text-sm font-semibold text-green-800 transition hover:bg-green-50">
                           View Supported Carriers
                        </button>

                        <div className="rounded-2xl bg-green-50 px-4 py-3 text-xs leading-6 text-green-700">
                           Redeem Credit availability depends on eligible container processing and posted account balance.
                        </div>
                     </div>

                  </div>
               </div>
            </section>
      </div>
         <Footer />
      </div>
   );
}